export enum TenantAuthorityEnum {
  /** A tenant selection already exists and is authoritative; the response must agree with it. */
  Reconcile = 'reconcile',
  /** No prior selection exists to reconcile against; this response establishes the tenant. */
  Establish = 'establish',
}
